var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('web-editor',{staticClass:"hidden-sm-and-down",attrs:{"docCreate":_vm.docCreate,"initial":_vm.dataItem},on:{"data":_vm.save}}),_c('mobile-editor',{staticClass:"hidden-md-and-up",attrs:{"docCreate":_vm.docCreate,"initial":_vm.dataItem},on:{"data":_vm.save}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }